import { render, staticRenderFns } from "./update-shelve.vue?vue&type=template&id=293a5bc8"
import script from "./update-shelve.vue?vue&type=script&lang=js"
export * from "./update-shelve.vue?vue&type=script&lang=js"
import style0 from "./update-shelve.vue?vue&type=style&index=0&id=293a5bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports